import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../../takeaway/services';
import { TPVServices } from '../../../tpv/services';

/**
 * Generated class for the OdsOrderInfoTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
    selector: 'page-ods-order-info-ticket-print',
    templateUrl: 'ods-order-info-ticket-print.html',
})
export class OdsOrderInfoTicketPrintPage {
    @Input() selected_list: any;
    @Input() orders_list: any;
    @Input() customerComment: string = '';
    @Input() origin: string = 'tk';
    footer: any;
    header: any;
    list_tax: any;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public takeawayServices: TakeawayServices,
        public tpvServices: TPVServices
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selected_list) {
            this.list_tax = this.globals.showIvaProducts(this.selected_list);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/ods/ods-view/ods-order-info-ticket-print/ods-order-info-ticket-print.ts